module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--link"
  }, [_c('div', {
    staticClass: "gradient-bg"
  }, [_c('module-spinner', {
    attrs: {
      "active": true,
      "floating": true
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35919082"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/TrackLink.vue
// module id = 312
// module chunks = 0